module.exports = __webpack_public_path__ + "img/icon_employees_en.82af5760.png";